import './SkillBar.css';
import styled, { css, keyframes } from 'styled-components';

function SkillBar({ percentage, color, name }) {
    // Define keyframes based on the passed percentage
    const fill = keyframes`
        0% { width: 0%; }
        100% { width: ${percentage}; }
    `;

    // Create dynamic styles
    const animPlayer = css`
        animation: ${fill} linear forwards;
        animation-timeline: view();
        animation-range: entry 0 cover 20%;
        background: ${color};
        width: ${percentage};
        height: 1.5vh;
    `;

    // Create a styled div with dynamic animation
    const AnimatedSkill = styled.div`
        ${animPlayer}
    `;

    return (
        <div className="skillBar">
            <h3>{name}</h3>
            <div className="SkillContainer">
                <AnimatedSkill>
                </AnimatedSkill>
            </div>
        </div>
    );
}

export default SkillBar;
